import { InfoOutlined } from '@mui/icons-material';
import { Box, styled, Typography } from '@mui/material';

export const AccordionTitleWrapper = styled(Box)`
  margin-left: -10px;
`;

export const AccordionTitle = styled(Typography)`
  font-weight: 500;
`;

export const AccordionContentWrapper = styled(Box)(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 20px 16px 36px;
  padding-bottom: 20px;
  border-bottom: 1px solid ${theme.palette.brand.disable};
`,
);

export const ComponentSectionWrapper = styled(Box)(
  ({ theme, $isConfirmation }) => `
  height: 264px;
  margin-bottom: ${$isConfirmation ? '90px' : '0'};
  border: 1px solid ${theme.palette.brand.disable};
  background-color: ${theme.palette.brand.lightGrey};
`,
);

export const ButtonsWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;

  > button {
    width: 45%;

    &:first-child {
      color: rgba(0, 0, 0, 0.6);
      border-color: rgba(0, 0, 0, 0.23);
    }
  }
`;

export const BackupsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const BackupTitle = styled(Typography)`
  font-weight: 400;
`;

export const ButtonWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  transform: translateY(-40px);
`;

export const ScheduleDateBox = styled(Box)(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    width: auto;
    height: auto;
    gap: 12px;
    padding: 10px;
    border-radius: 8px;
    border: 1px solid ${theme.palette.divider};
  `,
);

export const ScheduleHeader = styled('div')(
  ({ theme }) => `
    font-family: Roboto;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0;
    color: ${theme.palette.brand.black};
  `,
);
export const CheckBoxHeader = styled(Typography)`
  font-weight: 400;
  margin-top: 0.5rem;
`;

export const CheckBoxWrapper = styled(Typography)`
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
`;

export const EndDateLabelWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  > div > div {
    display: flex;
  }
`;

export const StyledInfoOutlinedIcon = styled(InfoOutlined)`
  font-size: 16px;
`;
export const SortableItemContainer = styled('div')(
  ({ theme }) => `
    &.dragged {
      z-index: 1200; // to override Mui drawer of 1200
      background-color: ${theme.palette.common.white} ;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    }
  `,
);
